<template>
  <el-submenu
    v-if="hasPermission('feature_group:products')"
    class="side-navigator__submenu"
    index="products">
    <template slot="title">
      Products
    </template>
    <el-menu-item
      v-if="hasPermission('feature:products:products')"
      class="side-navigator__menu-item"
      index="/products">
      Products
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:products:brands')"
      class="side-navigator__menu-item"
      index="/brands">
      Brands
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:products:vendors')"
      class="side-navigator__menu-item"
      index="/vendors">
      Vendors
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:products:verify')"
      class="side-navigator__menu-item"
      index="/products/verify">
      Verify
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'ProductsNavigationGroup',
  components: {
    NavigationIcon,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/ProductsNavigationGroup.vue